import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Hash, ShieldCheck, ArrowDownRight, Plus } from "lucide-react";
import BackButton from "@/components/BackButton";

const EVENT_LABEL = {
  certificate_issued: { label: "CERT ISSUED", color: "bg-accent text-accent-foreground" },
  topup: { label: "TOPUP", color: "bg-primary text-primary-foreground" },
  course_payment: { label: "PAYMENT", color: "bg-foreground text-background" },
  reward: { label: "REWARD", color: "bg-accent text-accent-foreground" },
  refund: { label: "REFUND", color: "bg-muted text-foreground" },
};

export default function AuditTrail() {
  const [events, setEvents] = useState([]);
  useEffect(() => {
    (async () => {
      const { data } = await api.get("/admin/audit-trail");
      setEvents(data);
    })();
  }, []);

  return (
    <div className="p-6 md:p-10">
      <BackButton />
      <div className="mt-5 mb-8">
        <div className="mono text-[10px] uppercase tracking-widest text-muted-foreground">
          /audit trail
        </div>
        <h1 className="font-display text-4xl font-extrabold tracking-tighter">
          On-chain audit trail
        </h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Every certificate issuance and wallet transaction is hashed and anchored to the simulated Polygon network.
        </p>
      </div>

      <div className="border-2 border-foreground bg-background">
        <div className="mono grid grid-cols-12 gap-2 border-b border-border bg-muted px-4 py-2 text-[10px] uppercase tracking-widest text-muted-foreground">
          <div className="col-span-2">Event</div>
          <div className="col-span-5">Subject</div>
          <div className="col-span-3">Txn hash</div>
          <div className="col-span-1 text-right">Block</div>
          <div className="col-span-1 text-right">Time</div>
        </div>
        {events.length === 0 ? (
          <div className="p-6 text-center text-sm text-muted-foreground">
            No events yet.
          </div>
        ) : (
          events.map((e) => {
            const meta = EVENT_LABEL[e.event_type] || { label: e.event_type.toUpperCase(), color: "bg-muted text-foreground" };
            return (
              <div
                key={e.ref_id}
                className="grid grid-cols-12 items-center gap-2 border-b border-border px-4 py-3 text-sm last:border-b-0"
              >
                <div className="col-span-2">
                  <span className={`mono inline-block px-2 py-0.5 text-[10px] uppercase tracking-widest ${meta.color}`}>
                    {meta.label}
                  </span>
                </div>
                <div className="col-span-5">{e.subject}</div>
                <div className="col-span-3 break-all font-mono text-[10px] text-muted-foreground">
                  {e.txn_hash.slice(0, 30)}…
                </div>
                <div className="col-span-1 text-right mono text-[10px]">#{e.block}</div>
                <div className="col-span-1 text-right mono text-[10px] text-muted-foreground">
                  {new Date(e.timestamp).toLocaleDateString()}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
